import React from "react";
import { Title, TitleProps, useMantineTheme } from "@mantine/core";

interface Heading3Props extends Omit<TitleProps, "order" | "styles"> {
  children: React.ReactNode;
  variant?: "default" | "shadow";
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Heading3 - Styled H3 component
 * Usage: <Heading3>Subsection Title</Heading3>
 * Usage with shadow: <Heading3 variant="shadow">Subsection Title</Heading3>
 */
export const Heading3: React.FC<Heading3Props> = ({
  children,
  variant = "default",
  className,
  style,
  ...props
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  const getTextShadow = () => {
    if (variant === "shadow") {
      return "0 1px 4px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2)";
    }
    return undefined;
  };

  return (
    <Title
      order={3}
      className={className}
      style={{
        color: other.textPrimary,
        fontWeight: 700,
        textShadow: getTextShadow(),
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
};

export default Heading3;
